<template>
  <div
    class="flex w-full min-w-0 flex-wrap gap-2.5 rounded-[20px] bg-white-gray px-4 py-3.5 text-[15px] leading-[1.35] font-helvetica-400 xl:grid xl:grid-cols-[repeat(auto-fit,minmax(min(100%,205px),1fr))] xl:gap-x-3 xl:gap-y-3 xl:px-5 xl:py-4 xl:text-[16px]"
  >
    <div class="min-w-0 max-w-full xl:min-w-0">
      <StatusSelect
        label="Статус:"
        variant="pill"
        :options="statusOptionsList"
        :model-value="statusValue"
        @update:model-value="onSelect('status', $event)"
      />
    </div>

    <div class="min-w-0 max-w-full xl:min-w-0">
      <StatusSelect
        label="Организация:"
        variant="pill"
        :options="orgOptionsList"
        :model-value="organizationValue"
        @update:model-value="onSelect('organization', $event)"
      />
    </div>

    <div class="min-w-0 max-w-full xl:min-w-0">
      <StatusSelect
        label="Контрагент:"
        variant="pill"
        :options="counterpartOptionsList"
        :model-value="counterpartValue"
        @update:model-value="onSelect('counterpart', $event)"
      />
    </div>

    <div class="min-w-0 max-w-full xl:min-w-0">
      <StatusSelect
        label="Автор:"
        variant="pill"
        :options="authorOptionsList"
        :model-value="authorValue"
        @update:model-value="onSelect('author', $event)"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed, ref, watch } from "vue";
import StatusSelect from "~/components/orders/StatusSelect.vue";

type Option = { label: string; value: string };

const props = withDefaults(
  defineProps<{
    status?: string;
    statusOptions?: Option[];
    organization?: string;
    organizationOptions?: Option[];
    counterpart?: string;
    counterpartOptions?: Option[];
    author?: string;
    authorOptions?: Option[];
  }>(),
  {
    statusOptions: () => [],
    organizationOptions: () => [],
    counterpartOptions: () => [],
    authorOptions: () => [],
  },
);

const emit = defineEmits<{
  (e: "update:status", value: string): void;
  (e: "update:organization", value: string): void;
  (e: "update:counterpart", value: string): void;
  (e: "update:author", value: string): void;
}>();

const statusOptionsList = computed(() => props.statusOptions);
const orgOptionsList = computed(() => props.organizationOptions);
const counterpartOptionsList = computed(() => props.counterpartOptions);
const authorOptionsList = computed(() => props.authorOptions);

const statusValue = ref(props.status ?? props.statusOptions[0]?.value ?? "");
const organizationValue = ref(
  props.organization ?? props.organizationOptions[0]?.value ?? "",
);
const counterpartValue = ref(
  props.counterpart ?? props.counterpartOptions[0]?.value ?? "",
);
const authorValue = ref(props.author ?? props.authorOptions[0]?.value ?? "");

watch(
  () => props.status,
  (val) => {
    if (val !== undefined && val !== statusValue.value) statusValue.value = val;
  },
);
watch(
  () => props.organization,
  (val) => {
    if (val !== undefined && val !== organizationValue.value)
      organizationValue.value = val;
  },
);
watch(
  () => props.counterpart,
  (val) => {
    if (val !== undefined && val !== counterpartValue.value)
      counterpartValue.value = val;
  },
);
watch(
  () => props.author,
  (val) => {
    if (val !== undefined && val !== authorValue.value) authorValue.value = val;
  },
);

const onSelect = (
  field: "status" | "organization" | "counterpart" | "author",
  value: string,
) => {
  if (field === "status") {
    statusValue.value = value;
    emit("update:status", value);
  } else if (field === "organization") {
    organizationValue.value = value;
    emit("update:organization", value);
  } else if (field === "counterpart") {
    counterpartValue.value = value;
    emit("update:counterpart", value);
  } else if (field === "author") {
    authorValue.value = value;
    emit("update:author", value);
  }
};
</script>
